const phoneIcon = "fa-mobile-alt fas";
const taxIDIcon = "fa-university far";
const passwordIcon = "fa-lock-alt fas";
const emailIcon = "fa-envelope far";

export { phoneIcon, taxIDIcon, passwordIcon, emailIcon };
